// extracted by mini-css-extract-plugin
export default {"title":"room_title_title__dk2dK","room_photo":"room_title_room_photo__T-FNJ"};